var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-card-group',{staticClass:"mb-3 address-holder",attrs:{"deck":""}},[_c('address-card',{attrs:{"model":_vm.syncSponsor,"show":_vm.showSponsor,"title":"Sponsor Address"}}),_c('address-card',{attrs:{"model":_vm.syncSite,"show":_vm.showSite,"title":"Site Address"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }